import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@f2e/ui/components/base"
import { EmptyDataPanel } from "@/components/System"

export interface Column<T> {
  title: string
  width?: string
  headerClassName?: string
  fieldName?: string
  render?: (row: T) => React.ReactNode
}

export interface DataTableProps<T> {
  columns: Column<T>[]
  data: T[]
  maxHeight?: string
}

const DataTable = <T,>({ columns, data, maxHeight }: DataTableProps<T>) => {
  return (
    <div style={{ maxHeight, overflowY: maxHeight ? "auto" : "visible" }}>
      <Table>
        <TableHeader>
          <TableRow>
            {columns.map((column, idx) => (
              <TableHead
                key={idx}
                style={{ width: column.width }}
                className={column.headerClassName}
              >
                {column.title}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.length === 0 ? (
            <TableRow className="text-gray-500 my-4">
              <TableCell colSpan={columns.length}>
                <EmptyDataPanel />
              </TableCell>
            </TableRow>
          ) : (
            data.map((row: T, idx) => (
              <TableRow key={idx}>
                {columns.map((column, cidx) => (
                  <TableCell key={cidx}>
                    {column.render
                      ? column.render(row)
                      : (row[column.fieldName as keyof T] as React.ReactNode)}
                  </TableCell>
                ))}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  )
}

export { DataTable }
export default DataTable
